import { render, staticRenderFns } from "./QueryDeviceTotal.vue?vue&type=template&id=8b1a4fe4&scoped=true"
import script from "./QueryDeviceTotal.vue?vue&type=script&lang=js"
export * from "./QueryDeviceTotal.vue?vue&type=script&lang=js"
import style0 from "./QueryDeviceTotal.vue?vue&type=style&index=0&id=8b1a4fe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1a4fe4",
  null
  
)

export default component.exports